import { MAAC_URL } from "@polifonia/env";
import queryString from "query-string";

export const AUTH_SOURCE_KEY = "auth-source";
export const AUTH_SOURCE_MAAC = "maac";

let isRedirecting = false;

export function isValidMaacRedirectSource(): boolean {
  return sessionStorage.getItem(AUTH_SOURCE_KEY) === AUTH_SOURCE_MAAC;
}

/**
 * Build a clean return path from the current location,
 * stripping auth-related params (e.g. `source`) that would cause redirect loops.
 */
function buildReturnPath(): string {
  const { source, ...rest } = queryString.parse(window.location.search);
  const search = queryString.stringify(rest);
  return (
    window.location.pathname +
    (search ? `?${search}` : "") +
    window.location.hash
  );
}

/**
 * Check whether redirect to the auth source is possible.
 * Does NOT perform the redirect — use {@link redirectToSource} for that.
 */
export function canRedirectToSource(): boolean {
  if (isRedirecting) return true;
  if (!isValidMaacRedirectSource()) return false;
  if (!MAAC_URL) return false;

  // Prevent redirect loop if MAAC_URL accidentally points to the current origin
  try {
    if (new URL(MAAC_URL).origin === window.location.origin) return false;
  } catch {
    return false;
  }

  return true;
}

/**
 * Redirect to the auth source (MAAC) with the current page path as
 * `ac_redirect` param. Uses a module-level flag to prevent duplicate
 * redirects from concurrent 401s.
 *
 * Callers should guard with {@link canRedirectToSource} first.
 */
export function redirectToSource(): void {
  if (isRedirecting) return;
  isRedirecting = true;

  window.location.href = queryString.stringifyUrl({
    url: MAAC_URL,
    query: { ac_redirect: buildReturnPath() },
  });
}

/**
 * Reset the redirecting state. Exported for testing only.
 */
export function resetRedirectingState(): void {
  isRedirecting = false;
}
